export default __webpack_public_path__ + "media/images/favicon-8ad10a2093a875c36724c85ea6ad575d.ico";